import React, { useState } from "react";
import { db } from "../../services/firebase";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { USE_LOCAL_FALLBACK } from "../../config/firebaseConfig";

function normCampus(v) {
  const x = String(v || "").toLowerCase().trim();
  if (!x) return "";
  if (x.includes("gapan")) return "gapan";
  if (x.includes("bulacan")) return "bulacan";
  return x;
}
function toSectionsArray(section, sections) {
  if (Array.isArray(sections) && sections.length) return sections.map(s => String(s).trim()).filter(Boolean);
  const s = String(section || "").trim();
  if (!s) return [];
  if (s.includes(",")) return s.split(",").map(x => x.trim()).filter(Boolean);
  return [s];
}

export default function DataNormalize() {
  const [log, setLog] = useState("");
  const [busy, setBusy] = useState(false);
  const [campusOnly, setCampusOnly] = useState("");

  function append(msg) {
    setLog(l => (l ? l + "\n" : "") + msg);
  }

  async function normalizeStudents() {
    setBusy(true); setLog("");
    try {
      let count = 0, changed = 0;
      if (USE_LOCAL_FALLBACK) {
        const raw = localStorage.getItem("students");
        const list = raw ? JSON.parse(raw) : [];
        const next = list.map(s => {
          const nc = normCampus(s.campus);
          const sa = toSectionsArray(s.section, s.sections);
          const upd = { ...s, campus: nc, sections: sa, section: sa[0] || "" };
          return upd;
        });
        localStorage.setItem("students", JSON.stringify(next));
        append(`Normalized ${next.length} local student(s).`);
      } else {
        const snap = await getDocs(collection(db, "students"));
        const docs = snap.docs;
        count = docs.length;
        for (const d of docs) {
          const data = d.data() || {};
          const nc = normCampus(data.campus);
          if (campusOnly && nc !== campusOnly) continue;
          const sa = toSectionsArray(data.section, data.sections);
          const patch = {};
          if (nc !== String(data.campus || "")) patch.campus = nc;
          if (JSON.stringify(sa) !== JSON.stringify(data.sections || [])) {
            patch.sections = sa;
            patch.section = sa[0] || "";
          }
          if (Object.keys(patch).length) {
            // eslint-disable-next-line no-await-in-loop
            await updateDoc(doc(db, "students", d.id), patch);
            changed += 1;
          }
        }
        append(`Scanned ${count} students; updated ${changed}.`);
      }
    } catch (e) {
      append(`Error: ${e.message || String(e)}`);
    } finally {
      setBusy(false);
    }
  }

  async function normalizePayments() {
    setBusy(true);
    try {
      let count = 0, changed = 0;
      if (USE_LOCAL_FALLBACK) {
        const raw = localStorage.getItem("payments");
        const list = raw ? JSON.parse(raw) : [];
        const studentsRaw = localStorage.getItem("students");
        const students = studentsRaw ? JSON.parse(studentsRaw) : [];
        const next = list.map(p => {
          let nc = normCampus(p.campus);
          if (!nc) {
            const s = students.find(x => String(x.id) === String(p.studentId));
            nc = s ? normCampus(s.campus) : "";
          }
          return { ...p, campus: nc };
        });
        localStorage.setItem("payments", JSON.stringify(next));
        append(`Normalized ${next.length} local payment(s).`);
      } else {
        const snap = await getDocs(collection(db, "payments"));
        const docs = snap.docs;
        count = docs.length;
        // Build student map for campus lookup
        const stuSnap = await getDocs(collection(db, "students"));
        const stuMap = new Map(stuSnap.docs.map(sd => {
          const dat = sd.data() || {};
          return [String(sd.id), normCampus(dat.campus)];
        }));
        for (const d of docs) {
          const data = d.data() || {};
          const current = normCampus(data.campus);
          let nc = current;
          if (!nc) {
            const sid = String(data.studentId || data.student_id || "");
            nc = stuMap.get(sid) || "";
          }
          if (nc !== String(data.campus || "")) {
            // eslint-disable-next-line no-await-in-loop
            await updateDoc(doc(db, "payments", d.id), { campus: nc });
            changed += 1;
          }
        }
        append(`Scanned ${count} payments; updated ${changed}.`);
      }
    } catch (e) {
      append(`Error: ${e.message || String(e)}`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="container py-4">
      <h3 className="mb-3">Data Normalization</h3>
      <p className="text-muted">Normalize campus strings to “gapan”/“bulacan” and ensure students have sections array. Also sets payment campus from student when missing.</p>
      <div className="row g-2 mb-3">
        <div className="col-md-4">
          <label className="form-label">Campus scope (optional)</label>
          <select className="form-select" value={campusOnly} onChange={e => setCampusOnly(e.target.value)}>
            <option value="">All</option>
            <option value="gapan">gapan</option>
            <option value="bulacan">bulacan</option>
          </select>
        </div>
      </div>
      <div className="d-flex gap-2 mb-3">
        <button className="btn btn-primary" onClick={normalizeStudents} disabled={busy}>Normalize Students</button>
        <button className="btn btn-outline-primary" onClick={normalizePayments} disabled={busy}>Normalize Payments</button>
      </div>
      <div className="card">
        <div className="card-body">
          <h6 className="mb-2">Logs</h6>
          <pre style={{ whiteSpace: "pre-wrap" }}>{log || "No logs yet"}</pre>
        </div>
      </div>
    </div>
  );
}

